import angular from 'angular';

import GroupComponent from './GroupComponent';
import GroupService from './GroupService';
import GroupPermissionsComponent from './GroupPermissionsComponent';
import uiTreeNestedNodeComponent from './uiTreeNestedNodeComponent';

export default angular
  .module('petroCloud.admin.groups', [])
  .service('GroupService', GroupService)
  .component(GroupComponent.name, GroupComponent)
  .component(GroupPermissionsComponent.name, GroupPermissionsComponent)
  .component(uiTreeNestedNodeComponent.name, uiTreeNestedNodeComponent)
  .name;
